/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { Link } from "react-router-dom";
import HomeIcon from '@mui/icons-material/HomeOutlined';

export function BreadCrumbs({ items }) {
  if (!items || !items.length) {
    return "";
  }

  return (
    <ul style={{ fontSize: 10 }} className="breadcrumb breadcrumb-transparent m-0 p-0">
      <li className="breadcrumb-item p-0">
        <Link to="/dashboard">
          <HomeIcon className="text-muted" />
        </Link>
      </li>
      {items.map((item, index) => (
        <li key={`bc${index}`} className="breadcrumb-item p-0">
          <a className="text-muted" href={item.pathname}>
            {item.title}
          </a>
        </li>
      ))}
    </ul>
  );
}
